export class RingBuffer<T> {
  private readonly items: T[] = [];

  constructor(private readonly capacity: number) {}

  push(item: T): void {
    this.items.push(item);

    if (this.items.length > this.capacity) {
      this.items.splice(0, this.items.length - this.capacity);
    }
  }

  clear(): void {
    this.items.length = 0;
  }

  toArray(): readonly T[] {
    return [...this.items];
  }

  size(): number {
    return this.items.length;
  }
}
